import loadjs from 'loadjs'

/* global Fides */

const cookieOverrides = () => {
  window.fides_overrides = {
    fides_locale: 'en-US'
  }
  document.documentElement.setAttribute('data-fides-style', 'wufoo')

  // store the original cookie setter and getter
  document.cookieSetter = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie').set

  let cookiesByNoticeKey = {}
  let previousConsent = {}

  function deleteCookie(cookieName) {
    const paths = [ '/' ]
    paths.forEach(path => {
      // Delete the cookie by original implementation
      document.cookieSetter(`${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`)
    })
  }

  function updateConsentSettings() {
    // Ensure Fides.consent exists
    if (!Fides.consent) {
      return
    }
    // Get current cookies from document.cookie
    const currentCookies = new Set(document.cookie.split('; ').map(cookie => cookie.split('=')[0]))
    // Detect revoked consents (categories that were previously `true` but now `false`)
    for (const [ noticeKey, wasConsented ] of Object.entries(previousConsent)) {
      if (wasConsented && !Fides.consent[noticeKey]) {
        // Find and delete only cookies that are currently present
        (cookiesByNoticeKey[noticeKey] || []).forEach(cookieName => {
          if (currentCookies.has(cookieName)) {
            deleteCookie(cookieName)
          }
        })
      }
    }
    // Save the latest consent state
    previousConsent = { ...Fides.consent }
  }

  function isCookieAllowed(cookieName) {
    // Ensure Fides.consent exists
    if (!Fides.consent) {
      return false
    }
    // Headless mode: Check if all notice groups are allowed
    if (!Fides.experience?.privacy_notices) {
      return Object.values(Fides.consent).every(value => value === true)
    }
    // Check if the cookie belongs to a consented notice_key
    for (const [ noticeKey, isConsented ] of Object.entries(Fides.consent)) {
      if (isConsented && cookiesByNoticeKey[noticeKey]?.has(cookieName)) {
        return true
      }
    }
    return false
  }

  function setCookie(cookie) {
    if (!cookie) return
    const cookieArr = cookie.split('=')
    if (!cookieArr.length) return
    const cookieName = cookieArr[0].trim()
    // Check consent before setting the cookie
    if (!isCookieAllowed(cookieName)) return
    // Set the cookie using the original JavaScript setter
    document.cookieSetter(cookie)
  }

  function enforceCookieSetter() {
    const originalDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie')
    Object.defineProperty(document, 'cookie', {
      get: originalDescriptor.get,
      set: setCookie,
      configurable: originalDescriptor.configurable,
      enumerable: originalDescriptor.enumerable,
    })
  }

  function addFidesExperienceNameToBody() {
    const experienceConfigName = Fides?.experience?.experience_config?.name
    if (experienceConfigName) {
      document.body.classList.add(experienceConfigName)
    }
  }

  // Listen for Fides consent updates
  window.addEventListener('FidesUpdated', () => {
    // Update consent settings when preferences change
    updateConsentSettings()
  })

  // Listen for when Fides is fully initialized
  window.addEventListener('FidesInitialized', () => {
    addFidesExperienceNameToBody()

    // Create a mapping of cookies grouped by notice_key
    // Headless mode does not have privacy_notices
    if (Fides.experience?.privacy_notices) {
      cookiesByNoticeKey = Object.fromEntries(
        Fides.experience.privacy_notices.map(notice => [
          notice.notice_key,
          new Set(notice.cookies.map(cookie => cookie.name)) // Store cookies in a Set for quick lookup
        ])
      )
    }
    enforceCookieSetter()
    updateConsentSettings()
  })
}

const init = () => {
  const { REACT_APP_FIDES_URL } = process.env

  if (!loadjs.isDefined('fides')) {
    cookieOverrides()
    loadjs(REACT_APP_FIDES_URL, 'fides', {
      async: true,
      before: (path, script) => {
        script.setAttribute('type', 'text/javascript')
        script.setAttribute('charset', 'UTF-8')
      }
    })
  }
}

export const FidesLoader = () => {
  init()
  return null
}
